<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container big-container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Finance</a>
                </li>
                <li class="breadcrumb-item" aria-current="page">
                  <router-link
                    to="/finance/invoice"
                    class="breadcrumb-item"
                    aria-current="page"
                  >
                    Invoice
                  </router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Receive Payment
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <div class="pull-left">
                  <h2>
                    Receive Payment
                    <span><i class="ic-office"></i></span>
                  </h2>
                  <p>Manage payments.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content" v-if="!nextStep">
      <div class="container big-container">
        <form @submit.prevent="nextPage()">
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required" for="company-select">Company</label>
                    <v-select
                      @input="getAllUnpaidBookings()"
                      id="company-select"
                      class="v-search-select"
                      placeholder="Company"
                      label="name"
                      v-model="companyId"
                      :disabled="isUpdate"
                      :options="companyOptions"
                      :clearable="false"
                      :searchable="true"
                      :filterable="true"
                      :reduce="(option) => option.id"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12" style="padding: 0 20px">
              <div class="row mt-10">
                <div class="col-sm-12">
                  <h2 class="required invoice-h2">Items</h2>
                  <small
                    class="form-text sts-danger"
                    v-if="isSubmitted && !$v.model.items.required"
                    style="display: block"
                  >
                    Items is required
                  </small>

                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="mutation-start-pickup">Pick-up Date</label>
                        <div class="dataTables_filter">
                          <i class="ic-date-picker"></i>
                          <VueCtkDateTimePicker
                            id="mutation-start-pickup"
                            v-model="pickUpDateFilter"
                            format="YYYY-MM-DD"
                            formatted="MMM DD, YYYY"
                            color="#025BC5"
                            auto-close
                            no-label
                            no-header
                            no-button
                            no-button-now
                            only-date
                            range
                            no-shortcuts
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="search">Search</label>
                        <input
                          id="search"
                          type="search"
                          class="form-control"
                          v-model="search"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="table-responsive table-p15">
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th>
                              <input
                                type="checkbox"
                                class="control-checkbox"
                                v-model="globalCheckbox"
                                v-if="reservations.length > 0"
                              />
                            </th>
                            <th>Reservation Code</th>
                            <th>Activity</th>
                            <th>Pick-up Date</th>
                            <th>Description</th>
                            <th class="text-right">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            style="height: 50px"
                            v-for="(val, index) in filterListReservation"
                            :key="index"
                          >
                            <td>
                              <input
                                type="checkbox"
                                checked
                                class="control-checkbox"
                                v-model="val.isActive"
                              />
                            </td>
                            <td>
                              <strong>{{ val.reservationCode }}</strong>
                            </td>
                            <td>{{ val.name }}</td>
                            <td>
                              {{ $helper.dateFormatted(val.pickUpDate) }}
                            </td>
                            <td>
                              <textarea
                                class="form-control"
                                @input="
                                  (e) => inputDescription(val.reservationId, e)
                                "
                                v-model="val.description"
                              ></textarea>
                            </td>
                            <td class="text-right">
                              <div class="d-flex flex-column">
                                <span>
                                  {{ val.txnAmount.currency }}
                                  {{
                                    $currencyFormat(
                                      val.txnAmount.currency,
                                      val.txnAmount.value
                                    )
                                  }}
                                </span>
                                <span
                                  class="local-currency-text"
                                  v-if="
                                    val.txnAmount.currency !==
                                    val.localAmount.currency
                                  "
                                >
                                  {{ val.localAmount.currency }}
                                  {{
                                    $currencyFormat(
                                      val.localAmount.currency,
                                      val.localAmount.value
                                    )
                                  }}
                                </span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 mt-20 mb-20">
              <div class="d-flex justify-end gap-20">
                <router-link to="/finance/invoice">
                  <button type="button" class="btn btn-default">Cancel</button>
                </router-link>
                <button
                  class="btn btn-outline-primary"
                  :disabled="this.reservations.length === 0"
                  type="submit"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>

    <section class="middle-content" v-else>
      <div class="container big-container">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required" for="company-select">Company</label>
                    <v-select
                      @input="getAllUnpaidBookings()"
                      id="company-select"
                      class="v-search-select"
                      placeholder="Company"
                      label="name"
                      v-model="companyId"
                      :disabled="isUpdate || nextStep"
                      :options="companyOptions"
                      :clearable="false"
                      :searchable="true"
                      :filterable="true"
                      :reduce="(option) => option.id"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="box-addons mt-20">
                <div class="panel-group" id="accordion">
                  <div class="panel panel-default">
                    <div class="panel-heading text-center">
                      <h4 class="panel-title">
                        <a
                          data-toggle="collapse"
                          data-parent="#accordion"
                          href="#collapse1"
                          class="--green"
                        >
                          <i class="ic-History mr-10"></i>Items ({{
                            model.items.length
                          }})
                        </a>
                      </h4>
                    </div>
                    <div id="collapse1" class="panel-collapse collapse">
                      <div class="panel-body">
                        <div class="trip-info">
                          <div class="table-responsive table-p15">
                            <table class="table table-hover">
                              <thead>
                                <tr>
                                  <th>Reservation Code</th>
                                  <th>Activity</th>
                                  <th>Pick-up Date</th>
                                  <th>Description</th>
                                  <th class="text-center">Qty</th>
                                  <th class="text-right">Rate</th>
                                  <th class="text-right">Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  style="height: 50px"
                                  v-for="(val, index) in model.items"
                                  :key="index"
                                >
                                  <td>
                                    <strong>{{ val.reservationCode }}</strong>
                                  </td>
                                  <td>{{ val.name }}</td>
                                  <td>
                                    {{ $helper.dateFormatted(val.pickUpDate) }}
                                  </td>
                                  <td>
                                    <textarea
                                      class="form-control"
                                      v-model="val.description"
                                    ></textarea>
                                  </td>
                                  <td class="text-center">
                                    {{ val.qty }}
                                  </td>
                                  <td class="text-right">
                                    <div class="d-flex flex-column">
                                      <span>
                                        {{ val.currency }}
                                        {{
                                          $currencyFormat(
                                            val.currency,
                                            val.amount
                                          )
                                        }}
                                      </span>
                                      <span
                                        class="local-currency-text"
                                        v-if="
                                          val.currency !== val.localCurrency
                                        "
                                      >
                                        {{ val.localCurrency }}
                                        {{
                                          $currencyFormat(
                                            val.localCurrency,
                                            val.localAmount
                                          )
                                        }}
                                      </span>
                                    </div>
                                  </td>
                                  <td class="text-right">
                                    <div class="d-flex flex-column">
                                      <span>
                                        {{ val.currency }}
                                        {{
                                          $currencyFormat(
                                            val.currency,
                                            val.totalAmount
                                          )
                                        }}
                                      </span>
                                      <span
                                        class="local-currency-text"
                                        v-if="
                                          val.currency !== val.localCurrency
                                        "
                                      >
                                        {{ val.localCurrency }}
                                        {{
                                          $currencyFormat(
                                            val.localCurrency,
                                            val.localTotalAmount
                                          )
                                        }}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required">Type</label>
                    <div class="d-flex">
                      <label
                        class="cursor-pointer"
                        v-for="(item, index) in types"
                        :key="index"
                        @click="model.markAsPaid = item.value"
                        :class="{ 'pl-20': index > 0 }"
                      >
                        <input
                          type="radio"
                          class="control-radio"
                          :value="item.value"
                          :checked="model.markAsPaid === item.value"
                          v-model="model.markAsPaid"
                        />
                        <span class="pl-5 font-weight-normal v-align-middle">
                          {{ item.text }}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required" for="invoice_number"
                      >Invoice Number</label
                    >
                    <input
                      id="invoice_number"
                      type="text"
                      class="form-control"
                      v-model="model.invoiceNumber"
                      :disabled="isUpdate"
                    />
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.invoiceNumber.required"
                      style="display: block"
                    >
                      Invoice number is required
                    </small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label class="required" for="mutation-start-pickup"
                      >Invoice Date</label
                    >
                    <div class="dataTables_filter">
                      <i class="ic-date-picker"></i>
                      <VueCtkDateTimePicker
                        v-model="model.invoiceDate"
                        id="mutation-start-pickup"
                        color="#025BC5"
                        no-label
                        no-header
                        no-button
                        no-button-now
                        format="YYYY-MM-DD"
                        formatted="MMM DD, YYYY"
                        only-date
                      />
                    </div>
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.invoiceDate.required"
                      style="display: block"
                    >
                      Invoice date is required
                    </small>
                  </div>
                </div>
                <div class="col-sm-6" v-if="model.markAsPaid">
                  <div class="form-group">
                    <label class="required" for="mutation-start-pickup"
                      >Payment Date</label
                    >
                    <div class="dataTables_filter">
                      <i class="ic-date-picker"></i>
                      <VueCtkDateTimePicker
                        v-model="model.paymentDate"
                        id="mutation-start-pickup"
                        color="#025BC5"
                        no-label
                        no-header
                        no-button
                        no-button-now
                        format="YYYY-MM-DDTHH:mm"
                        formatted="MMM DD, YYYY HH:mm"
                      />
                    </div>
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.paymentDate.required"
                      style="display: block"
                    >
                      Payment date is required
                    </small>
                  </div>
                </div>
                <div class="col-sm-6" v-if="model.markAsPaid">
                  <div class="form-group">
                    <label class="required" for="payment_id">Payment ID</label>
                    <input
                      id="payment_id"
                      type="text"
                      class="form-control"
                      v-model="model.refPaymentId"
                    />
                    <small
                      class="form-text sts-danger"
                      v-if="isSubmitted && !$v.model.refPaymentId.required"
                      style="display: block"
                    >
                      Payment ID is required
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 mt-20 mb-20">
              <div class="d-flex justify-end gap-20">
                <button
                  type="button"
                  class="btn btn-default"
                  @click.prevent="backPage()"
                >
                  Back
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  @click.prevent="submitInvoice()"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import invoiceService from "@/services/shop/invoiceService.js";
import companyService from "@/services/master/company/companyService.js";

export default {
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
      },
      model: {
        invoiceNumber: "",
        invoiceDate: "",
        refPaymentId: "",
        billTo: "",
        markAsPaid: false,
        items: [],
      },
      pickUpDateFilter: null,
      search: "",
      companyId: "",
      reservations: [],
      companyOptions: [],
      types: [
        { value: false, text: "Save" },
        { value: true, text: "Save & Mark as Paid" },
      ],
      isUpdate: false,
      isSubmitted: false,
      isLoading: false,
      nextStep: false,
      msg: "Please wait",
    };
  },
  validations() {
    const v = {
      model: {
        invoiceNumber: { required },
        invoiceDate: { required },
        billTo: { required },
        items: { required },
        refPaymentId: this.refPaymentIdValidation,
        paymentDate: this.paymentDateValidation,
      },
    };

    return v;
  },
  computed: {
    refPaymentIdValidation: function () {
      return this.model.markAsPaid ? { required } : {};
    },
    paymentDateValidation: function () {
      return this.model.markAsPaid ? { required } : {};
    },
    filterListReservation: function () {
      if (
        this.pickUpDateFilter &&
        this.pickUpDateFilter.start &&
        this.pickUpDateFilter.end &&
        this.search
      ) {
        return (
          this.reservations.length > 0 &&
          this.reservations.filter((val) => {
            const dateList = val.pickUpDate.substring(0, 10);
            return (
              dateList >= this.pickUpDateFilter.start &&
              dateList <= this.pickUpDateFilter.end &&
              val.reservationCode.includes(this.search)
            );
          })
        );
      } else if (
        this.pickUpDateFilter &&
        this.pickUpDateFilter.start &&
        this.pickUpDateFilter.end
      ) {
        return (
          this.reservations.length > 0 &&
          this.reservations.filter((val) => {
            const dateList = val.pickUpDate.substring(0, 10);
            return (
              dateList >= this.pickUpDateFilter.start &&
              dateList <= this.pickUpDateFilter.end &&
              val.reservationCode.includes(this.search)
            );
          })
        );
      } else if (this.search) {
        return (
          this.reservations.length > 0 &&
          this.reservations.filter((val) =>
            val.reservationCode.includes(this.search)
          )
        );
      } else {
        return this.reservations;
      }
    },
    globalCheckbox: {
      get() {
        return (
          this.filterListReservation.length > 0 &&
          this.filterListReservation.every((item) => item.isActive === true)
        );
      },
      set(value) {
        this.filterListReservation.forEach((valFR) => {
          let findR = this.reservations.find(
            (valR) => valR.reservationId === valFR.reservationId
          );

          findR.isActive = value;
        });
      },
    },
  },
  async created() {
    this.$helper.scrollTop();
    this.isLoading = true;
    if (this.$route.query && this.$route.query.inv_id) {
      this.nextStep = true;
      this.isUpdate = true;
      await this.getRetrieveInvoice(this.$route.query.inv_id);
    }
    await this.getCompanies();
    this.isLoading = false;
  },
  methods: {
    inputDescription(id, e) {
      this.reservations = this.reservations.map((val) => {
        if (val.reservationId === id) {
          return { ...val, description: e.target.value };
        } else {
          return { ...val };
        }
      });
    },
    async getCompanies() {
      this.companyOptions = await companyService.getAllActive();
    },
    async getAllUnpaidBookings() {
      this.isLoading = true;
      this.model.billTo = "";
      this.reservations = [];
      try {
        const response = await invoiceService.getAllUnpaidBookings(
          this.companyId
        );

        if (response.isSuccess) {
          this.model.billTo = response.data.billTo;
          this.reservations =
            response.data.reservations.length > 0 &&
            response.data.reservations.map((val) => ({
              ...val,
              isActive: false,
            }));
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getRetrieveInvoice(id) {
      try {
        const response = await invoiceService.getRetrieveInvoice(id);

        if (response.isSuccess) {
          this.model = {
            invoiceNumber: response.data.number,
            invoiceDate: response.data.invoiceDate,
            billTo: response.data.billTo,
            refPaymentId: response.data.paymentId,
            items: response.data.items,
          };
          this.reservations = response.data.items.map((val) => ({
            ...val,
            isActive: true,
          }));
          this.companyId = response.data.companyId;
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    nextPage() {
      this.model.items = this.reservations
        .filter((x) => x.isActive)
        .flatMap((item) =>
          item.details.map((val) => ({
            reservationId: item.reservationId,
            reservationCode: item.reservationCode,
            pickUpDate: item.pickUpDate,
            utcPickUpDate: item.utcPickUpDate,
            itemName: item.name,
            itemDescription: item.description,
            itemCurrency: item.txnAmount.currency,
            itemAmount: item.txnAmount.value,
            // details
            description: val.description,
            name: val.name,
            currency: val.txnAmount.currency,
            amount: val.txnAmount.value,
            totalAmount: val.txnAmount.total,
            localCurrency: val.localAmount.currency,
            localAmount: val.localAmount.value,
            localTotalAmount: val.localAmount.total,
            qty: val.qty,
          }))
        );

      this.isLoading = true;
      this.nextStep = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    backPage() {
      this.model.items = [];
      this.isLoading = true;
      this.nextStep = false;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    submitInvoice() {
      this.isSubmitted = true;

      this.$v.model.$touch();
      if (this.$v.model.$error) {
        this.$nextTick(() => this.$helper.focusToFieldError());
        return;
      }

      if (this.$route.query && this.$route.query.inv_id) this.editInvoice();
      else this.createOfflineInvoice();
    },
    async editInvoice() {
      this.isLoading = true;
      try {
        const response = await invoiceService.updateInvoice(
          this.$route.query.inv_id,
          this.model
        );

        if (response.isSuccess) {
          this.$notification.success("Update invoice successfully", {
            title: "Success",
          });
          this.$router.push({
            path: "/finance/invoice",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async createOfflineInvoice() {
      this.isLoading = true;
      try {
        let paymentDate = null;

        const company = this.companyOptions.find(
          (val) => val.id === this.companyId
        );

        if (this.model.paymentDate) {
          paymentDate = this.model.paymentDate + ":00";
        }

        let itemList = [];

        const reservationActive = this.reservations
          .filter((x) => x.isActive)
          .map((val) => val.reservationCode);

        reservationActive.forEach((code, i) => {
          const filterModelItems = this.model.items.filter(
            (val) => val.reservationCode === code
          );

          const sumAmount = filterModelItems.reduce((sum, item) => {
            return sum + (item.localAmount || 0);
          }, 0);

          const detailData = filterModelItems.map((item) => ({
            name: item.name,
            description: item.description,
            qty: item.qty,
            localCurrency: item.localCurrency,
            localAmount: item.localAmount,
          }));

          const itemListData = {
            reservationId: filterModelItems[0].reservationId,
            name: filterModelItems[0].itemName,
            description: filterModelItems[0].itemDescription,
            currency: filterModelItems[0].currency,
            amount: sumAmount,
            details: detailData,
          };
          itemList.push(itemListData);
        });

        let payload = {
          companyId: company.id,
          companyName: company.name,
          billTo: this.model.billTo,
          invoiceDate: this.model.invoiceDate,
          invoiceNumber: this.model.invoiceNumber,
          markAsPaid: this.model.markAsPaid,
          refPaymentId: this.model.refPaymentId,
          items: itemList,
        };

        if (this.model.markAsPaid) {
          payload = {
            ...payload,
            paymentDate: paymentDate,
          };
        }

        const response = await invoiceService.createOfflineInvoice(payload);

        if (response.isSuccess) {
          this.$notification.success("Successfully", { title: "Success" });
          this.$router.push({
            path: "/finance/invoice",
          });
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  updated() {
    this.$helper.collapseMenu("deposit");
    this.$helper.setNavigationClass("invoice-link");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/invoice/ReceivePayment.vue